var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxicon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    rx: 37.5,
    fill: "#3F0099"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_220_13326)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36.325,
    cy: 35.2752,
    r: 12.825,
    fill: "url(#paint0_linear_220_13326)",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4665 47.8406L31.467 47.8408C31.5812 47.8857 31.6999 47.9085 31.8175 47.9085C32.1928 47.9085 32.5459 47.6841 32.6932 47.3143C32.8878 46.8325 32.6534 46.2832 32.1686 46.0889L32.1685 46.0889C27.3734 44.1685 24.2748 39.595 24.2748 34.4316C24.2748 27.5074 29.9068 21.8754 36.8311 21.8754C43.7553 21.8754 49.3873 27.5074 49.3873 34.4316C49.3873 38.5817 47.3315 42.4744 43.8908 44.8386C43.4601 45.1333 43.3529 45.7205 43.647 46.1504C43.9414 46.5806 44.5268 46.6922 44.959 46.394C48.9128 43.6755 51.2748 39.205 51.2748 34.4316C51.2748 26.4671 44.7956 19.9879 36.8311 19.9879C28.8665 19.9879 22.3873 26.4671 22.3873 34.4316C22.3873 40.3704 25.9526 45.635 31.4665 47.8406Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8873 29.3691C35.8873 29.8901 36.3101 30.3129 36.8311 30.3129C37.352 30.3129 37.7748 29.8901 37.7748 29.3691V25.9941C37.7748 25.4732 37.352 25.0504 36.8311 25.0504C36.3101 25.0504 35.8873 25.4732 35.8873 25.9941V29.3691Z",
    fill: "#EDFBF9",
    stroke: "#EDFBF9",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8873 42.8691C35.8873 43.3901 36.3101 43.8129 36.8311 43.8129C37.352 43.8129 37.7748 43.3901 37.7748 42.8691V39.4941C37.7748 38.9732 37.352 38.5504 36.8311 38.5504C36.3101 38.5504 35.8873 38.9732 35.8873 39.4941V42.8691Z",
    fill: "#EDFBF9",
    stroke: "#EDFBF9",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.847 58.5639L20.8474 58.5644C21.0283 58.8453 21.3321 59.0001 21.6435 59.0001C21.8186 59.0001 21.9944 58.953 22.1513 58.8528L40.0706 47.4462L46.2863 53.6619C46.6544 54.0301 47.2526 54.0301 47.6208 53.6619L61.1208 40.1619C61.4889 39.7938 61.4889 39.1956 61.1208 38.8275C60.7526 38.4593 60.1544 38.4593 59.7863 38.8275L46.9544 51.6594L40.8724 45.5775C40.5591 45.2641 40.072 45.2113 39.6984 45.449L21.1359 57.2615L21.1358 57.2616C20.6979 57.541 20.5677 58.1241 20.847 58.5639Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5123 46.2441C59.5123 46.7651 59.9351 47.1879 60.4561 47.1879C60.977 47.1879 61.3998 46.7651 61.3998 46.2441V39.4941C61.3998 38.9732 60.977 38.5504 60.4561 38.5504H53.7061C53.1851 38.5504 52.7623 38.9732 52.7623 39.4941C52.7623 40.0151 53.1851 40.4379 53.7061 40.4379H59.5123V46.2441Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4561 40.4379H37.6748C39.5913 40.4379 41.1498 38.8794 41.1498 36.9629C41.1498 35.0464 39.5913 33.4879 37.6748 33.4879H35.9873C35.1111 33.4879 34.3998 32.775 34.3998 31.9004C34.3998 31.0257 35.1111 30.3129 35.9873 30.3129H40.2061C40.727 30.3129 41.1498 29.8901 41.1498 29.3691C41.1498 28.8482 40.727 28.4254 40.2061 28.4254H35.9873C34.0708 28.4254 32.5123 29.9838 32.5123 31.9004C32.5123 33.8169 34.0708 35.3754 35.9873 35.3754H37.6748C38.551 35.3754 39.2623 36.0882 39.2623 36.9629C39.2623 37.8375 38.551 38.5504 37.6748 38.5504H33.4561C32.9351 38.5504 32.5123 38.9732 32.5123 39.4941C32.5123 40.0151 32.9351 40.4379 33.4561 40.4379Z",
    fill: "#EDFBF9",
    stroke: "#EDFBF9",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_220_13326",
    x1: 38.4625,
    y1: 22.4502,
    x2: 38.4625,
    y2: 51.7645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_220_13326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.5,
    height: 40.5,
    fill: "white",
    transform: "translate(20.7998 18.4004)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxicon4);
export default __webpack_public_path__ + "static/media/boxicon4.4e4ac0ed8deed81237612b9059bd14f1.svg";
export { ForwardRef as ReactComponent };